class Repository {
    constructor() {
        this.endpoint = window.akita.urls.api + "/v1/me/password";
    }
    update(payload, request) {
        return axios.put(this.endpoint, payload, request);
    }
}

module.exports = Repository;
